import { useEffectPlease } from "@features/utils";
import { Button } from "@radix-ui/themes";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { twMerge } from "tailwind-merge";

// Tags selection step
export const TagsCloud = ({
  rawTagOptions,
  onChange,
}: {
  rawTagOptions: { label: string; value: string }[];
  onChange: (val: string[]) => void;
}) => {
  const { t } = useTranslation();
  const [tags, setTags] = useState<string[]>([]);

  // Randomized options plus "Other" at the end
  const [tagOptions, setTagOptions] = useState<
    { label: string; value: string }[]
  >([]);

  // Randomize options on component mount
  useEffectPlease(() => {
    // Fisher-Yates shuffle algorithm
    const shuffled = [...rawTagOptions];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    // Add "Other" option at the end
    setTagOptions([
      ...shuffled,
      { value: "other", label: t("welcome.greetings.other") },
    ]);
  }, []);

  useEffectPlease(() => {
    onChange(tags);
  }, [tags]);

  const toggleTag = (tagValue: string) => {
    setTags((prev) =>
      prev.includes(tagValue)
        ? prev.filter((i) => i !== tagValue)
        : [...prev, tagValue]
    );
  };

  return (
    <div className="flex flex-wrap gap-2">
      {tagOptions.map((tag) => (
        <Button
          key={tag.value}
          variant={tags.includes(tag.value) ? "solid" : "outline"}
          color={tags.includes(tag.value) ? "blue" : "gray"}
          onClick={() => toggleTag(tag.value)}
          className="transition-all space-x-0 px-0"
        >
          <span
            className={twMerge(
              "w-2 inline-block text-left pl-1.5",
              tags.includes(tag.value) && "w-3.5"
            )}
          >
            {tags.includes(tag.value) ? "✓" : ""}
          </span>
          {tag.label}
          <span
            className={twMerge(tags.includes(tag.value) ? "w-0.5" : "w-2")}
          />
        </Button>
      ))}
    </div>
  );
};
